import { useMemo } from 'react';
import { SWRConfiguration } from 'swr';

import { UserActivityEventsGetParams } from '~/data/userActivity/types';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { UserActivityApiClient } from '~/services/Http';
import {
  GetUserActivityEventsParamsDto,
  UserActivityEventListResultDto,
} from '~/services/Http/client.iam.generated';

export const useGetUserActivityEvents = (
  props: UserActivityEventsGetParams,
  swrConfig?: SWRConfiguration,
): UseSWROutput<UserActivityEventListResultDto> => {
  const { filters } = useMemo(() => {
    return {
      filters: JSON.stringify(
        new GetUserActivityEventsParamsDto(props).toJSON(),
      ),
    };
  }, [props]);

  return useSWR<UserActivityEventListResultDto>(
    ['useGetUserActivityEvents', filters],
    ([_key, filters]) => UserActivityApiClient.list(filters),
    swrConfig,
  );
};
